interface ThreeDSecureAuthRequest {
  colorDepth: string;
  javaEnabled: boolean;
  javascriptEnabled: boolean;
  language: string;
  screenHeight: string;
  screenWidth: string;
  timezone: string;
  userAgent: string;
}

const ALLOWED_COLOR_DEPTHS = [1, 4, 8, 15, 16, 24, 48];

const getClosestLowerDepthValue = (): number => {
  // In case the actual value does not exist in the allowed values, use the closest lower value.
  const actualColorDepth = screen.colorDepth;

  const firstGreaterDepthIndex = ALLOWED_COLOR_DEPTHS.findIndex((depth) => depth > actualColorDepth);
  if (firstGreaterDepthIndex === -1) {
    return ALLOWED_COLOR_DEPTHS.at(-1);
  } else if (firstGreaterDepthIndex === 0) {
    return ALLOWED_COLOR_DEPTHS[0];
  } else {
    return ALLOWED_COLOR_DEPTHS[firstGreaterDepthIndex - 1];
  }
};

export const get3DSAuthRequest = (): ThreeDSecureAuthRequest => ({
  colorDepth: getClosestLowerDepthValue().toString(),
  javaEnabled: false,
  javascriptEnabled: true,
  language: navigator.language,
  screenHeight: screen.height.toString(),
  screenWidth: screen.width.toString(),
  timezone: new Date().getTimezoneOffset().toString(),
  userAgent: navigator.userAgent,
});
